/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Container, InputGroup, InputGroupText, Input, Row, Col, CardText, CardTitle, Card, Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { IoIosSearch } from "react-icons/io";
import { MdLocationOn } from "react-icons/md";
import { FiBriefcase } from "react-icons/fi";
import SelectRouteModal from '../../components/Modals/SelectRouteModal';
import CreateNewRouteModal from '../../components/Modals/CreateNewRouteModal';
import PointsListingModal from '../../components/Modals/PointsListingModal';
import useDebounce from '../../components/Debounce/Debounce';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import './SearchCustomPoint.scss';
import NoDataFound from '../../components/NoDataFound/NoDataFound';
import { routeDetail, updateRouteDetail } from '../../services/myRoute.service';
import { useSelector } from 'react-redux';
import swal from 'sweetalert';

function SearchCustomPoint({ isUserLoggedIn }) {
    const [showModal, setShowModal] = useState(false);
    const [showListModal, setShowListModal] = useState(false);
    const [showCreateRouteModal, setShowCreateRouteModal] = useState(false);
    const [route, setRoute] = useState(null);
    const [routeName, setRouteName] = useState(null);
    const [data, setData] = useState([]);
    const [debouceValue, setDebouceValue] = useState("");
    const [pointName, setPointName] = useState(null);
    const [mkmID, setMkmId] = useState();
    const [showSpinner, setShowSpinner] = useState(false);
    const [values, setValues] = useState({
        search_input: ''
    });

    var regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;

    const userName = useSelector((state) => state.userDetailReducer.userData.userName);
    const debounce = useDebounce();
    const navigate = useNavigate();
    const location = useLocation();
    // const { from } = location?.state || '';

    const toggle = () => {
        setShowModal(!showModal);
        setRoute(null);
    };

    useEffect(() => {
        setTimeout(() => {
            window?.scrollTo({ top: 0, behavior: 'smooth' })
        }, 0);
    }, []);

    const createNewRoute = () => {
        setShowModal(false);
        setShowCreateRouteModal(true);
    };

    const addToRoute = (id) => {
        if (location?.state?.data[0]?.key === 'addPointAbove') {
            addPointAbove(id)
        }
        else if (location?.state?.data[0]?.key === 'addPoints') {
            addPointInLast(id)
        }
        else {
            setMkmId(id)
            setShowModal(true);
        }
    };

    const addPointInLast = async (id) => {
        if (isUserLoggedIn) {
            const arr = location?.state?.data[0]?.arr
            if (arr?.length < 25) {
                let index = location?.state?.data[0]?.index
                index = arr.length;
                let requestBody = [];
                arr?.splice(index, 0, {
                    orderNumber: 0,
                    place: {
                        mkmID: id,
                        cityE: data?.city,
                        stateE: data?.country,
                        poi: data?.lat + ',' + data?.lng,
                        title: data?.city,
                        userFavorite: false
                    },
                    visited: false,

                });
                requestBody = arr?.map((item, i) => {
                    return {
                        mkmID: item?.place?.mkmID || item?.mkmID,
                        orderNumber: i,
                        place: {
                            mkmID: id,
                            cityE: data?.city,
                            stateE: data?.country,
                            poi: data?.lat + ',' + data?.lng,
                            title: data?.city,
                            userFavorite: false
                        },
                        visited: item?.visited
                    }
                });
                try {
                    console.log('requestBody', requestBody)
                    let res = await updateRouteDetail(requestBody, {
                        userName: userName,
                        routeID: location?.state?.data[0]?.route_id,
                    });
                    if (res && res?.status === 200) {
                        toast.success("Point Added Successfully In Your Route!", {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 2000
                        })
                        setTimeout(() => {
                            navigate(`/my-routes-detail/${location?.state?.data[0]?.route_id}/${location?.state?.data[0]?.route_name}`)
                        }, 1000);
                    }
                } catch (err) {
                    toast.error(
                        err?.response?.data?.message ||
                        "Oops.. something went wrong, try again !!!",
                        {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 2000,
                        }
                    );
                }
            }
            else {
                toast.warning("Max of only 25 points can be added to a route, Kindly remove a point to add a new point.", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 2000
                })
            }
        }
        else {
            const notLoggedIn = await swal({
                title: "Please Continue to Log In",
                text: "You want to add this point in your Route?",
                icon: "warning",
                buttons: ["Cancel", "Log In"],
            })
            if (notLoggedIn) {
                navigate('/sign-in');
            }
        }

    }

    const addPointAbove = async (id) => {
        if (isUserLoggedIn) {
            const arr = location?.state?.data[0]?.arr
            if (arr?.length < 25) {
                const index = location?.state?.data[0]?.index
                let requestBody = [];
                arr?.splice(index, 0, {
                    orderNumber: 0,
                    place: {
                        mkmID: id,
                        cityE: data?.city,
                        stateE: data?.country,
                        poi: data?.lat + ',' + data?.lng,
                        title: data?.city,
                        userFavorite: false
                    },
                    visited: false,

                });
                requestBody = arr?.map((item, i) => {
                    return {
                        mkmID: item?.place?.mkmID || item?.mkmID,
                        orderNumber: i,
                        place: {
                            mkmID: id,
                            cityE: data?.city,
                            stateE: data?.country,
                            poi: data?.lat + ',' + data?.lng,
                            title: data?.city,
                            userFavorite: false
                        },
                        visited: item?.visited
                    }
                });
                try {
                    let res = await updateRouteDetail(requestBody, {
                        userName: userName,
                        routeID: location?.state?.data[0]?.route_id,
                    });
                    if (res && res?.status === 200) {
                        toast.success("Point Added Successfully In Your Route!", {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 2000
                        })
                        setTimeout(() => {
                            navigate(`/my-routes-detail/${location?.state?.data[0]?.route_id}/${location?.state?.data[0]?.route_name}`)
                        }, 1000);
                    }
                } catch (err) {
                    toast.error(
                        err?.response?.data?.message ||
                        "Oops.. something went wrong, try again !!!",
                        {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 2000,
                        }
                    );
                }
            } else {
                toast.warning("Max of only 25 points can be added to a route, Kindly remove a point to add a new point.", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 2000
                })
            }
        }
        else {
            const notLoggedIn = await swal({
                title: "Please Continue to Log In",
                text: "You want to add this point in your Route?",
                icon: "warning",
                buttons: ["Cancel", "Log In"],
            })
            if (notLoggedIn) {
                navigate('/sign-in');
            }
        }
    }

    const selectRoute = async () => {
        let existingData;
        if (route?.id) {
            try {
                let response = await routeDetail({
                    userName: userName,
                    routeID: route?.id
                });
                if (response && response?.status === 200) {
                    existingData = response?.data?.data
                }

                let requestBody = [];
                if (existingData?.length < 25) {
                    if (existingData?.length === 0) {
                        requestBody?.push({
                            mkmID: mkmID,
                            orderNumber: 0,
                            visited: false
                        });
                    } else if (existingData?.length === 1) {
                        requestBody?.push({
                            mkmID: existingData[0]?.place?.mkmID,
                            orderNumber: 0,
                            visited: false
                        });
                        requestBody?.push({
                            mkmID: mkmID,
                            orderNumber: 1,
                            visited: false
                        })
                    } else {
                        existingData?.splice(existingData?.length, 0, {
                            mkmID: mkmID,
                            orderNumber: existingData?.length,
                            visited: false
                        });
                        requestBody = existingData?.map((item, i) => {
                            return {
                                mkmID: item?.place?.mkmID || item?.mkmID,
                                orderNumber: i,
                                visited: item?.visited
                            }
                        });
                    }
                    try {
                        setShowSpinner(true);
                        let res = await updateRouteDetail(requestBody, {
                            userName: userName,
                            routeID: route?.id,
                        });
                        if (res && res?.status === 200) {
                            toast.success("Point Added Successfully In Your Route!", {
                                position: toast.POSITION.TOP_RIGHT,
                                autoClose: 2000
                            })
                            setShowSpinner(false);
                        }
                    } catch (err) {
                        toast.error(
                            err?.response?.data?.message ||
                            "Oops.. something went wrong, try again !!!",
                            {
                                position: toast.POSITION.TOP_RIGHT,
                                autoClose: 2000,
                            }
                        );
                        setShowSpinner(false);
                    }
                    setRoute('');
                    setShowModal(false);
                }
                else {
                    toast.warning("Max of only 25 points can be added to a route, Kindly remove a point to add a new point.", {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 2000
                    })
                    setShowSpinner(false);
                }
                setRoute('');
                setShowModal(false);
            } catch (error) {
                console.log(error)
                setShowSpinner(false);
            };
        }
        if (!route?.id) {
            toast.error("Please Select The Route.", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000
            })
            setShowSpinner(false);
        }
    }

    function makeid(length) {
        var result = '';
        var characters = '0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() *
                charactersLength));
        }
        return result;
    }

    const autoCompleteLocation = () => {
        var id = makeid(7)
        return new Promise((resolve, reject) => {
            var autocomplete;
            autocomplete = new window.google.maps.places.Autocomplete((document.getElementById("search_input")))
            window.google.maps.event.addListener(autocomplete, 'place_changed', function () {
                const near_place = autocomplete.getPlace();
                const country = near_place.address_components.find((elem) => elem.types[0] === 'country')
                // const state = near_place.address_components.find((elem) => elem.types[0] === 'administrative_area_level_1')
                const city = near_place.address_components.find((elem) => elem.types[0] === 'locality')
                const object = {
                    id: id,
                    lat: near_place.geometry.location.lat(),
                    lng: near_place.geometry.location.lng(),
                    country: country.long_name,
                    // state: state.long_name,
                    city: city.long_name
                }
                resolve(object)
            });
        })
    }

    // useEffect(() => {
    //     if (values?.search) {
    //         let apiUrl =
    //             'https://maps.googleapis.com/maps/api/place/details/json?place_id=' +
    //             values?.search +
    //             '&key=AIzaSyB5uzN0BRqJqja6R7mFncAZytZxtZpt16Q';
    //         if (values?.search?.length > 2) {
    //             var config = {
    //                 method: 'get',
    //                 url: apiUrl,
    //                 headers: {},
    //             };

    //             axios(config)
    //                 .then(function (response) {
    //                     // const getDATA = response?.data?.predictions;
    //                     // let tempArr = [];
    //                     // if (getDATA && getDATA?.length > 0) {
    //                     //     getDATA?.map(ele => {
    //                     //         let tempObj = {
    //                     //             title: ele?.structured_formatting?.main_text,
    //                     //             data: [
    //                     //                 {
    //                     //                     id: ele?.place_id,
    //                     //                     name: ele?.structured_formatting?.main_text,
    //                     //                     text: ele?.structured_formatting?.secondary_text,
    //                     //                     address: ele?.description,
    //                     //                 },
    //                     //             ],
    //                     //         };
    //                     //         tempArr?.push(tempObj);
    //                     //     });
    //                     //     setData(tempArr);
    //                     // }
    //                 })
    //                 .catch(function (error) {
    //                     toast.error("Oops Something went wrong.", {
    //                         position: toast.POSITION.TOP_RIGHT,
    //                         autoClose: 1000,
    //                     });

    //                 });
    //         } else {
    //             toast.info("Please enter atleast 3 characters to get result.", {
    //                 position: toast.POSITION.TOP_RIGHT,
    //                 autoClose: 1000,
    //             });
    //         }
    //     }
    //     else {
    //         setData([]);
    //     }
    // }, [debouceValue]);

    const handleChange = (e) => {
        const newData = { ...values };
        newData[e?.target?.id] = e?.target?.value?.trim().replace(regex, '');
        setValues(newData);
        debounce(() => setDebouceValue(newData));
    }

    const getPlaces = async () => {
        let response = await autoCompleteLocation();
        setData(response)
    }

    useEffect(() => {
        // if (values?.search) {
        getPlaces();
        // }
        // else {
        //     setData([]);
        // }
    }, [debouceValue])

    return (
        <div className='main_section search_custom_point'>
            <Container>
            <SelectRouteModal
                route={route}
                setRoute={setRoute}
                showModal={showModal}
                toggle={toggle}
                createNewRoute={createNewRoute}
                selectRoute={selectRoute}
                showSpinner={showSpinner}
            />
            <CreateNewRouteModal
                showCreateRouteModal={showCreateRouteModal}
                setShowCreateRouteModal={setShowCreateRouteModal}
                showListModal={showListModal}
                setShowListModal={setShowListModal}
                routeName={routeName}
                setRouteName={setRouteName}
                pointName={pointName}
                setPointName={setPointName}
            />
            <PointsListingModal
                showListModal={showListModal}
                setShowListModal={setShowListModal}
                setRouteName={setRouteName}
                routeName={routeName}
                pointName={pointName}
                setPointName={setPointName}
            />
            {/* <SearchBar /> */}
            <div className='breadcrumb_section'>
                <Container >
                    <Breadcrumb className="breadcrumb">
                        <BreadcrumbItem>
                            <Link to="/" className="breadcrumb_item1">Home</Link>
                        </BreadcrumbItem>
                        <BreadcrumbItem>
                            <Link to="/my-routes" className="breadcrumb_item1">My Routes</Link>
                        </BreadcrumbItem>
                        {/* <BreadcrumbItem>
                            <Link to="/my-routes-detail" className="breadcrumb_item1">Details</Link>
                        </BreadcrumbItem> */}
                        <BreadcrumbItem active>
                            <Link to="#" className="breadcrumb_item2">Custom Point Address</Link>
                        </BreadcrumbItem>
                    </Breadcrumb>
                </Container>
            </div>
            <div className='search_point_section'>
                <Container fluid>
                    <div className="search_point_box">
                        <div className="search_point_box_header">
                            <div className="search_input">
                                <InputGroup size="sm">
                                    <InputGroupText style={{ backgroundColor: "#FFFFFF" }}>
                                        <IoIosSearch size={25} />
                                    </InputGroupText>
                                    <Input
                                        type='search'
                                        id='search_input'
                                        name='search'
                                        value={values?.search}
                                        onChange={handleChange}
                                        placeholder="Search for a custom point"
                                        maxLength="100"
                                        autoComplete='off'
                                    />
                                </InputGroup>
                            </div>
                        </div>
                        <div className="search_point_block">
                            <div className='search_point_grid_view'>
                                <Row >
                                    {data?.length === 0 ? <NoDataFound /> :
                                        <Col lg="6" md="12"
                                        //  key={items?.id}
                                        >
                                            <Card body>
                                                <div className="card_header">
                                                    <div className="right_section">
                                                        <CardTitle tag="h5">{data?.city}</CardTitle>
                                                    </div>
                                                </div>
                                                {/* <CardText>{items?.text} </CardText> */}
                                                <div className="card_bottom">
                                                    {/* <Link to="#" onClick={share}><FiShare2 size={20} /></Link> */}

                                                    <div className="right_section">
                                                        <CardText>{data?.city + ',' + data?.country}</CardText>
                                                        <Link to="#" className="location_icon">
                                                            <MdLocationOn size={18} />
                                                        </Link>
                                                    </div>
                                                </div>
                                                <div className="card_footer">
                                                    <Link to={`/along-the-way-to-here/${data?.lat + ',' + data?.lng}`} state={{ from: 'customAddress', data: location?.state?.data }} className="btn along_the_route">Along the way to here</Link>
                                                    {/* <Link to={`/explore-near-by/${data?.lat + ',' + data?.lng}`} state={{ from: "Custom Address" }}
                                                        className="btn explore">Explore Near By</Link> */}
                                                    <Link to='#' className="btn addroute" onClick={() => addToRoute(Number(data?.id))}><FiBriefcase />&nbsp;Add to route</Link>
                                                </div>
                                            </Card>
                                        </Col>
                                        // data?.map((item) => (
                                        //     item?.data?.map((items) => (
                                        //         <Col lg="6" md="12" key={items?.id}>
                                        //             <Card body>
                                        //                 <div className="card_header">
                                        //                     <div className="right_section">
                                        //                         <CardTitle tag="h5">{items?.name}</CardTitle>
                                        //                     </div>
                                        //                 </div>
                                        //                 <CardText>{items?.text} </CardText>
                                        //                 <div className="card_bottom">
                                        //                     {/* <Link to="#" onClick={share}><FiShare2 size={20} /></Link> */}

                                        //                     <div className="right_section">
                                        //                         <CardText>{items?.address}</CardText>
                                        //                         <Link to="#" className="location_icon">
                                        //                             <MdLocationOn size={18} />
                                        //                         </Link>
                                        //                     </div>
                                        //                 </div>
                                        //                 <div className="card_footer">
                                        //                     <Link to='/along-route' className="btn along_the_route"> Along the route</Link>
                                        //                     <Link to={`/explore-near-by/${items?.poi}`} state={{ from: "Custom Address" }}
                                        //                         className="btn explore">Explore Near By</Link>
                                        //                     <Link to='#' className="btn addroute" onClick={() => addToRoute(items?.id)}><FiBriefcase />Add to route</Link>

                                        //                 </div>
                                        //             </Card>
                                        //         </Col>
                                        //     ))
                                        // ))
                                    }
                                </Row>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
            </Container>
        </div>
    )
}

export default SearchCustomPoint
